import { Empty } from "antd";

import styles from './index.module.scss';

export default function Page404() {
  return <div className={styles.notFoundWrapper}>
    <Empty description="Not Found"  />
  </div>;
}
